<script lang="ts" setup>
import MIcon from "./medicus/MIcon";
import { ref, type ComponentPublicInstance } from "vue";
import MTooltip from "./medicus/MTooltip";
defineProps({
  text: String,
});
const iconEl = ref<ComponentPublicInstance | null>(null);
</script>
<template>
  <m-icon ref="iconEl" name="fa-solid fa-circle-question">
    <m-tooltip :text="text as string" :scroll-target="iconEl?.$el">
      <slot>
        <span>{{ text }}</span>
      </slot>
    </m-tooltip>
  </m-icon>
</template>
